"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractParserWithWordBoundaryChecking = void 0;

var AbstractParserWithWordBoundaryChecking = /*#__PURE__*/function () {
  function AbstractParserWithWordBoundaryChecking() {
    _classCallCheck(this, AbstractParserWithWordBoundaryChecking);
  }

  _createClass(AbstractParserWithWordBoundaryChecking, [{
    key: "pattern",
    value: function pattern(context) {
      var innerPattern = this.innerPattern(context);
      return new RegExp("(\\W|^)".concat(innerPattern.source), innerPattern.flags);
    }
  }, {
    key: "extract",
    value: function extract(context, match) {
      var header = match[1];
      match.index = match.index + header.length;
      match[0] = match[0].substring(header.length);

      for (var i = 2; i < match.length; i++) {
        match[i - 1] = match[i];
      }

      return this.innerExtract(context, match);
    }
  }]);

  return AbstractParserWithWordBoundaryChecking;
}();

exports.AbstractParserWithWordBoundaryChecking = AbstractParserWithWordBoundaryChecking;